<div class="modal-header blue">
  <h4 class="modal-title">User Search</h4>
  <a href="javascript:void(0)" class="modal-close-btn" (click)="close()"></a>
</div>

<form [formGroup]="userForm">
  <div class="modal-body flex-container">
    <div class="d-flex mb-3 pb-2" *ngIf="isSearchAvilable">
      <div class="w-100 mr-3">
        <span class="input-label">Search</span>
        <input
          type="text"
          class="input"
          placeholder="Enter User Name"
          formControlName="name"
        />
      </div>

      <button class="button-outline w-80px" (click)="doSearch()">Search</button>
    </div>

    <div
      class="user-groups-table flex-fill"
      infiniteScroll
      (scrolled)="onScroll()"
      [immediateCheck]="true"
      [scrollWindow]="false"
    >
      <ng-container *ngIf="usersDTO; else loading">
        <table class="standart-table" *ngIf="usersDTO?.length; else empty">
          <thead class="standart-table-header">
            <tr>
              <ng-container>
                <th width="30%">name</th>
                <th width="70%">
                  {{ isPermissionMode ? 'Permissions' : 'Groups' }}
                </th>
                <th style="width: 60px"></th>
              </ng-container>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let user of usersDTO">
              <td>{{ user.firstName }} {{ user.lastName }}</td>
              <td *ngIf="!isPermissionMode">
                <div class="d-flex flex-wrap">
                  <div *ngFor="let group of user.groups; index as i">
                    {{
                      user.groups
                        ? i === user.groups.length - 1
                          ? group.name
                          : group.name + ', '
                        : ''
                    }}
                  </div>
                  <ng-container *ngIf="!user.groups?.length">
                    N/A
                  </ng-container>
                </div>
              </td>
              <td *ngIf="isPermissionMode">
                <ng-container
                  *ngFor="let permission of user.permissions; index as i"
                >
                  {{
                    user.permissions
                      ? i === user.permissions.length - 1
                        ? permission.name
                        : permission.name + ', '
                      : ''
                  }}
                </ng-container>

                <ng-container *ngIf="!user.permissions?.length">
                  N/A
                </ng-container>
              </td>
              <td>
                <div class="d-flex">
                  <label class="checkbox ml-auto">
                    <input
                      type="checkbox"
                      (change)="onCheckboxChange(user)"
                      [checked]="user.checked"
                    />
                  </label>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </ng-container>
    </div>
  </div>

  <div class="modal-footer">
    <button
      type="button"
      class="button ml-auto"
      [disabled]="!selectedUser"
      (click)="save()"
    >
      {{ isPermissionMode ? 'Copy user permissions' : 'Copy groups' }}
    </button>
  </div>
</form>

<ng-template #loading>
  <loader></loader>
</ng-template>

<ng-template #empty>
  <empty-state size="sm" title="No results found"></empty-state>
</ng-template>
